import { render } from "./admin-list-page.vue?vue&type=template&id=16b5e500&scoped=true"
import script from "./admin-list-page.vue?vue&type=script&lang=js"
export * from "./admin-list-page.vue?vue&type=script&lang=js"

import "./admin-list-page.vue?vue&type=style&index=0&id=16b5e500&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b5e500"]])

export default __exports__